var qty = {

	init: function () {
		$('.m-qty:not(.js-qty-done)').each(function () {
			var wrapper = $(this);
			var form = wrapper.closest('form');
			var lessBtn = wrapper.find('.js-less');
			var input = wrapper.find('.js-input');
			var moreBtn = wrapper.find('.js-more');
			var min = input.attr('min');
			var max = input.attr('max');
			var step = input.attr('step');

			// submit
			form.off('submit').on('submit', function () {
				if (location.href.indexOf('/basket') > -1) {
					popups.loader();
					return true;
				}
				quickAdd.add(form);
				return false;
			});

			// check
			function _check(checkNaN, autosubmit) {
				var val = parseInt(input.val(), 10);
				// val
				if (checkNaN && isNaN(val)) {
					input.val(min);
					val = min;
				}
				if (val < min) {
					input.val(min);
					val = min;
				}
				if (val > max) {
					input.val(max);
					val = max;
				}
				// more button
				moreBtn.addClass('disabled');
				if (val < max) {
					moreBtn.removeClass('disabled');
				}
				// submit
				if (autosubmit) {
					form.submit();
				}
				// zero check
				if (val == 0) {
					var group = wrapper.closest('.m-quick-add');
					if (group.length) {
						quickAdd.reset(group);
					}
				}
			}

			// load
			_check(true, false);

			// less
			lessBtn.on('click', function () {
				input.val(parseInt(input.val(), 10) - 1);
				_check(false, true);
				return false;
			});

			// more
			moreBtn.on('click', function () {
				input.val(parseInt(input.val(), 10) + 1);
				_check(false, true);
				return false;
			});

			// keyup
			var timer = null;
			input.on('keyup', function () {
				return;
				clearTimeout(timer);
				timer = setTimeout(function () {
					_check(false, true);
				}, 500);				
			});

			// paste
			input.on('paste', function () {
				_check(false, true);
			});

			// change
			input.on('change', function () {
				_check(true, true);
			});

			// done
			wrapper.addClass('js-qty-done');
		});
	}

};

$(function () {
	qty.init();
	site.doc.ajaxComplete(function () {
		qty.init();
	});
});